// extracted by mini-css-extract-plugin
export var chip = "_5m-0";
export var filterDropdown = "_5m-5";
export var filterItem = "_5m-6";
export var icon = "_5m-1";
export var removeButton = "_5m-3";
export var removeIcon = "_5m-4";
export var separator = "_5m-2";